/* eslint-disable max-lines */
import { clear_token, get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import Swal from 'sweetalert2';
import TimePicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import Loader from "@/components/Loader/LoaderView";
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import CreateEvent from "@/components/FloatingButton/FloatingButtonComponent.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import PromoCode from '@/components/PromoCode/event_promo_code.vue';


import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";
import {
  view_events_lifecycle_methods,
  view_events_update_methods,
} from "@/views/View_Events/view_events_helper";
import event_utility_helpers from "@/views/View_event/event_utility_helpers";
import {
  append_active_organization_form_data,
  append_active_organization_id,
  get_active_organization_id,
} from "@/utils/organization_profile";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";


const CALENDAR_ID = process.env.VUE_APP_CALENDAR_ID;
const GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;

/* global jsQR */
/* global bootstrap */

export default {
  components: {
    HomeNavBar,
    FullCalendar,
    Loader,
    MenuSideBar,
    CreateEvent,
    InactivityModal,
    TimePicker,
    PromoCode,
  },
  computed: {
   is_event_dates_locked() {
    return this.is_start_date_locked;
   },
   is_start_date_locked() {
    if (!this.event_id) return false; // create flow
    if (!this.editing_event_start_ts) return false;
    const now = new Date();
    now.setSeconds(0, 0);
    return this.editing_event_start_ts < now.getTime();
   },
   is_editing_event() {
    return !!this.event_id;
  },
   has_valid_basic_info() {
    return !!(this.event_name?.trim() && this.event_type?.id);
  },
  has_valid_location_and_link() {
    const typeName = this.event_type?.name;
    if (!typeName) return false;
    const needsLocation = ['hybrid', 'in person'].includes(typeName);
    const needsLink = ['hybrid', 'online'].includes(typeName);
    if (needsLocation && !this.location?.trim()) return false;
    if (needsLink && !this.event_link?.trim()) return false;
    return true;
  },
   has_valid_dates() {
     const startObj = this.get_event_start_date_time?.();
     if (!startObj) return false;

     // Validate start date+time is not in the past (guard even though inputs have min=...).
     const now = new Date();
     now.setSeconds(0, 0);
     if (startObj < now && !this.is_start_date_locked) return false;

    const shouldValidateEnd = !!this.end_date || !!this.end_time || !!this.show_event_end_date;
    if (shouldValidateEnd) {
      const endObj = this.get_event_end_date_time?.();
      if (!endObj) return false;
      if (!this.is_event_dates_locked && startObj >= endObj) return false;
    }
    return true;
  },
  is_valid_event() {
    return this.has_valid_basic_info &&
           this.has_valid_location_and_link &&
           this.has_valid_dates;
  },
    selectedTicketsData() {
      return this.selectedTickets
        .map(id => {
          const t = this.allTickets.find(ticket => Number(ticket.id) === Number(id));
          if (!t) return null;

          // Check if this ticket is already assigned
          const assigned = this.event_tickets?.find(et => Number(et.ticket.id) === Number(id));

          return {
            id: t.id,
            name: t.name,
            price: assigned ? parseFloat(assigned.price) : 0,
            quantity: assigned ? Number(assigned.quantity) : 1,
            start_date: assigned ? assigned.start_date?.substring(0, 16) : '',
            end_date: assigned ? assigned.end_date?.substring(0, 16) : '',
            readOnly: !!assigned
          };
        })
        .filter(Boolean);
    },
   min_datetime() {
     const now = new Date();
     now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
     return now.toISOString().slice(0, 16);
   },

   filtered_upcoming_events() {
     return this.filter_event_list(this.upcoming_events, 'upcoming');
   },
   filtered_my_events() {
     return this.filter_event_list(this.my_events, 'my_events');
   },
   filtered_past_events() {
     return this.filter_event_list(this.past_events, 'past');
   },

   active_event_filters_draft() {
     const tab = this.active_events_tab;
     return (this.event_filters_draft_by_tab && Reflect.get(this.event_filters_draft_by_tab, tab)) || this.get_default_event_filters();
   },
   },
  data() {
    return ({
      home_feature_icons: HOME_FEATURE_ICONS,
      current_quantity: null,
      event_ticket_attendees: [],
      isScanning: false,
      isProcessing: false,
      html5Reader: null,
      currentEventId: null,
      availableTickets: [],
      edit_event_ticket: [],
      selectedTickets: [],
      event_start_time: '',
      event_tickets: [],
      ticketDetails: {},
      edit_end_date: '',
      edit_start_date: '',
      edit_ticket_id: '',
      edit_name: '',
      edit_is_sold_out: '',
      edit_price: '',
      allTickets: [],
      businessName: '',
      my_tickets: [],
      is_tickets_loading: true,
       isFirstTime: false,
       searchQuery: "",
       active_tab: 'upcoming',
       active_events_tab: 'upcoming',
       event_filters_template: {
         search: '',
         start_from: '',
         end_to: '',
         price_range: '',
         min_price: '',
         max_price: '',
       },
       event_filters_draft_by_tab: {
         upcoming: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
         my_events: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
         past: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
       },
       event_filters_applied_by_tab: {
         upcoming: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
         my_events: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
         past: { search: '', start_from: '', end_to: '', price_range: '', min_price: '', max_price: '' },
       },
       event_badge_now_ms: Date.now(),
      event_badge_timer_id: null,
      event_card_image_fit_by_id: {},
      selectedEvent: {},
       activeDates: {},
      event_start_date: '',
      editing_event_start_ts: null,
      selectedItemId: [],
      cbo_domain: false,
      workbook_domain: false,
      styledCalendarId: CALENDAR_ID,
      imagePreview: null,
      recurring_type: '',
      recurring_patterns: [],
      event_link: "",
      event_types: [],
      event_type: '',
      events: [],
      event_id: null,
      selectedTicket: null,
      token_exists: false,
      selectedExtraId: [],
      selectedExtraItemId: [],
      eventExtras: [],
      extraItems: [],
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
        'user_id': '',
      },
      chapter: "",
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      currentMonthYear: "",
      selectedEvent: {},
      portals: [],
      selectedPortalId: '',
      event_name: "",
      description: "",
      start_date: "",
      start_time: '',
      end_date: "",
      end_time: '',
      rsvp_start_date: "",
      rsvp_start_time: '',
      rsvp_end_date: "",
      rsvp_end_time: '',
      event_capacity:0,
      organizer: "",
      location: "",
      portal_id: "",
      files: [],
      latitude: null,
      longitude: null,
      loading: true,
      upload_media: null,
      event_description: '',
      errors: {},
      menu_name: "",
      menu_items: [],
      filteredExtras: [],
      item_name: '',
      item_description: '',
      item_price: 0,
      // selectedExtraText: '',
      showExtrasForm: false,
      isSubmitting: false,
      extras: [],
      extraForms: [],
      show_add_extras: true,
      currentDate: new Date(),
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      days: [],
      selectedDate: new Date(),
      calendarOptions: {
        plugins: [dayGridPlugin],
        events: [],
        currentMonth: new Date().getMonth(),
        currentYear: new Date().getFullYear(),
        selectedDate: null,
        weekdays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        daysInMonth: [],
        initialDate: new Date().toISOString().split('T')[0],
      },
      showCamera: true,
      scanResultBox: false,
      scanSuccess: false,
      scanErrorMessage: "",
      scanData: {},
      upcoming_events: [],
      past_events: [],
      is_recurring: false,
      recurrenceSelections: {},
      is_free: true,
      original_event_is_free: null,
      tickets: [],
      assignedTicketIds: [],
      is_event_loading: false,
      is_upcoming_initial_loading: false,
      is_upcoming_loading_more: false,
      has_loaded_upcoming_events: false,
      ticket: {
        name: '',
      },
      page: 1,
      page_size: 6,
      has_more: true,
      selected_event_agenda: null,
      show_rsvp_capacity: false,
      promo_input: "",
      promo_message: "",
      promo_status: "",
      is_applying: false,
      applied_promo: null,
      map_auto_complete: null,
      map_auto_complete_input: null,
      ticket_show_dropdown:false,
      show_event_end_date:false,
      my_events:[],
      is_my_events_loading:false,
      is_my_events_loading_more: false,
      my_events_page: 1,
      my_events_page_size: 6,
      my_events_has_more: true,
       my_events_total_pages: 0,
      share_menu_open: {},
      _view_events_document_click_handler: null,
      is_upcoming_events_loading_more: false,
     });
    },
  async mounted() {
    this.start_event_badge_timer();
    this.register_scroll_container();
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.load_google_map_event();

    await this.resolve_active_organization_for_events();
    this.fetchEventTypes();
    this.fetchEvents();
    if (this.token_exists) this.get_user_events(true);

    this.register_event_tabs();
    this.restore_pending_rsvp();
    this.register_event_modals();
    this.open_create_event_modal_from_home();
    this.get_all_tickets();
    this.load_styled_calendar_script();
    this.generateCalendar();
    this.register_calendar_modal_render();
    this.set_client_domain_flags();
    this.initialize_rsvp_table();
    this.register_view_events_listeners();
  },
  beforeUnmount() {
    if (this.event_badge_timer_id) {
      window.clearInterval(this.event_badge_timer_id);
      this.event_badge_timer_id = null;
    }
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }
    if (this._view_events_document_click_handler) {
      document.removeEventListener('click', this._view_events_document_click_handler);
      this._view_events_document_click_handler = null;
    }
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },
  watch: {

    event_name(newValue) {
      if (newValue.trim()) this.errors.event_name = null;
    },
    location(newValue) {
      if (newValue.trim()) this.errors.location = null;
    },
    organizer(newValue) {
      if (newValue.trim()) this.errors.organizer = null;
    },
    start_date() {
      this.validate_event_date_range?.();
    },
    end_date() {
      this.validate_event_date_range?.();
    },
    rsvp_start_date() {
      this.errors.rsvp_start_date = null;
    },
    rsvp_end_date() {
      this.errors.rsvp_end_date = null;
    },
    event_type: {
      handler(newType) {
        if (newType.name !== "online") {
          this.$nextTick(() => {
            this.load_google_map_event();

          });
        }
      },
      deep: true
    },
    events: {
      handler() {
        this.$nextTick(() => {
          // Prevent reinitializing if already initialized
          if ($.fn.DataTable.isDataTable('#rsvpTable')) {
            $('#rsvpTable').DataTable().destroy();
          }

          $('#rsvpTable').DataTable({
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available"
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
      ...view_events_lifecycle_methods,
      ...view_events_update_methods,
      format_ticket_schedule: event_utility_helpers.format_ticket_schedule,
      register_event_card_image_fit(event_id, event) {
        const image = event?.target;
        if (!image || !event_id) return;

        const natural_width = image.naturalWidth || 0;
        const natural_height = image.naturalHeight || 0;

        if (!natural_width || !natural_height) return;

        const next_fit = natural_height > natural_width ? "cover" : "contain";

        const fit_by_id = {
          ...(this.event_card_image_fit_by_id || {}),
        };

        Reflect.set(fit_by_id, String(event_id), next_fit);

        this.event_card_image_fit_by_id = fit_by_id;
      },

      get_event_card_image_fit(event_id) {
        const fit_by_id = this.event_card_image_fit_by_id || {};
        const saved_fit = Reflect.get(fit_by_id, String(event_id));

        return saved_fit === "cover" ? "contain" : "cover";
      },
      handle_realtime_event(event) {
        handle_event_list_realtime(this, event);
      },
    get_default_event_filters() {
      return ({ ...(this.event_filters_template || { search: '', start_from: '', end_to: '', price_range: '' }) });
    },

    get_default_event_filters_by_tab() {
      const base = this.get_default_event_filters();
      return ({
        upcoming: ({ ...base }),
        my_events: ({ ...base }),
        past: ({ ...base }),
      });
    },

    set_active_tab(tabId) {
      this.active_tab = tabId;
      if (['upcoming', 'my_events', 'past'].includes(tabId)) {
        this.active_events_tab = tabId;
      }
    },

    apply_event_filters() {
      const tab = this.active_events_tab;
      const next = { ...(this.active_event_filters_draft || this.get_default_event_filters()) };
      this.event_filters_applied_by_tab = {
        ...(this.event_filters_applied_by_tab || this.get_default_event_filters_by_tab()),
        [tab]: next,
      };
      $('#filtersOffcanvas .btn[data-bs-dismiss="offcanvas"]').click();

      if (tab === 'upcoming') {
        this.page = 1;
        this.upcoming_events = [];
        this.has_more = true;
        this.has_loaded_upcoming_events = false;
        this.fetch_upcoming_search_results();
      }
    },

    clear_event_filters() {
      const tab = this.active_events_tab;
      const defaults = this.get_default_event_filters();
      this.event_filters_draft_by_tab = {
        ...(this.event_filters_draft_by_tab || this.get_default_event_filters_by_tab()),
        [tab]: { ...defaults },
      };
      this.event_filters_applied_by_tab = {
        ...(this.event_filters_applied_by_tab || this.get_default_event_filters_by_tab()),
        [tab]: { ...defaults },
      };

      if (tab === 'upcoming') {
        this.page = 1;
        this.upcoming_events = [];
        this.has_more = true;
        this.has_loaded_upcoming_events = false;
        this.fetchEvents(); // Refetch original data
      }
    },

    event_filters_active_for(tab) {
      const f = (this.event_filters_applied_by_tab && Reflect.get(this.event_filters_applied_by_tab, tab)) || {};
      return !!(
        (f.search && String(f.search).trim()) ||
        f.start_from ||
        f.end_to ||
        (f.price_range && String(f.price_range).trim()) ||
        f.min_price ||
        f.max_price
      );
    },

    parse_date_input_start(dateStr) {
      if (!dateStr) return null;
      const d = new Date(`${dateStr}T00:00:00`);
      return Number.isNaN(d.getTime()) ? null : d;
    },

    parse_date_input_end(dateStr) {
      if (!dateStr) return null;
      const d = new Date(`${dateStr}T23:59:59.999`);
      return Number.isNaN(d.getTime()) ? null : d;
    },

    get_event_start_dt(event) {
      const dt = this.parse_local_date_time(event?.start_date, event?.start_time);
      if (dt) return dt;
      const fallback = new Date(event?.start_date);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },

    get_event_end_dt(event) {
      const dt = this.parse_local_date_time(event?.end_date, event?.end_time);
      if (dt) return dt;
      const fallback = new Date(event?.end_date);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },

    event_ticket_price_range(event) {
      if (event?.is_free) return { min: 0, max: 0 };

      const prices = (event?.event_tickets || [])
        .map((t) => Number(t?.price))
        .filter((n) => Number.isFinite(n));

      if (!prices.length) return { min: null, max: null };
      return ({ min: Math.min(...prices), max: Math.max(...prices) });
    },

    event_matches_search(event, rawQuery) {
      const query = (rawQuery || '').toString().trim().toLowerCase();
      if (!query) return true;

      const haystack = [
        event?.event_name,
        event?.location,
        event?.event_type?.name,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return haystack.includes(query);
    },

    event_matches_start_date_range(event, startFrom, endTo) {
      const eventStart = this.get_event_start_dt(event);
      if (!eventStart) return false;

      if (startFrom && eventStart < startFrom) return false;
      if (endTo && eventStart > endTo) return false;
      return true;
    },

    event_matches_price_range(event, minPrice, maxPrice) {
      if (!Number.isFinite(minPrice) && !Number.isFinite(maxPrice)) return true;

      const { min: evMin, max: evMax } = this.event_ticket_price_range(event);

      // If we don't have price info for a paid event, exclude when price filters are active.
      if (evMin === null || evMax === null) return false;
      if (Number.isFinite(minPrice) && evMax < minPrice) return false;
      if (Number.isFinite(maxPrice) && evMin > maxPrice) return false;

      return true;
    },

    event_matches_filters(event, filters) {
      const f = filters || {};

      if (!this.event_matches_search(event, f.search)) return false;

      const startFrom = this.parse_date_input_start(f.start_from);
      const endTo = this.parse_date_input_end(f.end_to);
      if (!this.event_matches_start_date_range(event, startFrom, endTo)) return false;

      const rangeFromSelect = this.parse_price_range(f.price_range);
      const minPrice = rangeFromSelect ? rangeFromSelect.min : null;
      const maxPrice = rangeFromSelect ? rangeFromSelect.max : null;
      return this.event_matches_price_range(event, minPrice, maxPrice);
    },

    parse_price_range(value) {
      if (!value) return null;

      const v = String(value).trim();
      if (!v) return null;

      if (v.endsWith('-plus')) {
        const minPart = v.replace('-plus', '');
        const min = Number(minPart);
        if (!Number.isFinite(min)) return null;
        return ({ min, max: null });
      }

      const parts = v.split('-');
      if (parts.length !== 2) return null;

      const min = Number(parts[0]);
      const max = Number(parts[1]);
      if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
      return ({ min, max });
    },

    filter_event_list(events, tab) {
      const list = Array.isArray(events) ? events : [];
      const active_tab = tab || this.active_events_tab || 'upcoming';
      if (active_tab !== 'upcoming') {
        return list;
      }
      return list;
    },

    fetch_upcoming_search_results() {
      if (this.is_upcoming_initial_loading || this.is_upcoming_loading_more) return;

      const filters = this.event_filters_applied_by_tab.upcoming;
      const request_data = {
        query: filters.search,
        min_price: filters.min_price || null,
        max_price: filters.max_price || null,
        start_date: filters.start_from || null,
        end_date: filters.end_to || null,
        page: this.page,
        page_size: this.page_size,
      };

      const is_initial_load = this.page === 1 && this.upcoming_events.length === 0;
      this.is_upcoming_initial_loading = is_initial_load;
      this.is_upcoming_loading_more = !is_initial_load;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/search_events_api/`,
        method: "POST",
       contentType: "application/json",
        headers: {
          ...(get_token() ? { Authorization: `Token ${get_token()}` } : {})
        },
        data: JSON.stringify(append_active_organization_id(request_data)),
        success: (response) => {
          if (response.status === "success") {
            const results = response.data.results || [];
            if (this.page === 1) {
              this.upcoming_events = results;
            } else {
              results.forEach(event => {
                if (!this.upcoming_events.some(e => e.id === event.id)) {
                  this.upcoming_events.push(event);
                }
              });
            }
            this.page = response.data.page + 1;
            this.has_more = Boolean(response.data.has_more && results.length > 0);
          }
        },
        error: (xhr) => {
          this.has_more = false;
          console.error("Search API error:", xhr.responseText);
        },
        complete: () => {
          this.is_upcoming_initial_loading = false;
          this.is_upcoming_loading_more = false;
          this.has_loaded_upcoming_events = true;
        }
      });
    },
    get_events_response_payload(data) {
      return data.organization_data || data.data || {};
    },
    get_events_endpoint() {
      return get_active_organization_id()
        ? `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_organization_events/`
        : `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_events_api/`;
    },
    parse_local_date_time(dateStr, timeStr) {
      if (!dateStr) return null;

      let dateString = dateStr;
      let timeString = timeStr;

      if (typeof dateString !== 'string') dateString = String(dateString);
      if (timeString != null && typeof timeString !== 'string') timeString = String(timeString);

      // Handle a combined date+time string like "YYYY-MM-DD HH:mm(:ss)"
      // or locale strings like "MM/DD/YYYY HH:mm AM/PM" by deferring to Date parsing.
      if (!timeString && /[T ]\d{1,2}:\d{2}/.test(dateString)) {
        const parsed = new Date(dateString);
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }

      if (dateString.includes('T')) {
        const dateTimeParts = dateString.split('T');
        dateString = dateTimeParts[0];
        timeString = dateTimeParts[1] || '';
      }

      // Support "YYYY-MM-DD HH:mm" (space separator)
      if (dateString.includes(' ') && !timeString) {
        const dateTimeParts = dateString.split(' ');
        dateString = dateTimeParts[0];
        timeString = dateTimeParts[1] || '';
      }

      if (!timeString) return null;

      // Normalize common API time formats like "HH:mm:ssZ", "HH:mm:ss.sssZ", "HH:mm:ss+02:00"
      // so we can safely parse as a local time.
      if (typeof timeString === 'string') {
        timeString = timeString.trim();
        // Allow "HH:mm AM/PM"
        const ampmMatch = timeString.match(/^(\d{1,2}):(\d{2})\s*([AP]M)$/i);
        if (ampmMatch) {
          let hours24 = Number(ampmMatch[1]);
          const minutes = Number(ampmMatch[2]);
          const meridiem = ampmMatch[3].toUpperCase();
          if (meridiem === 'PM' && hours24 < 12) hours24 += 12;
          if (meridiem === 'AM' && hours24 === 12) hours24 = 0;
          timeString = `${String(hours24).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
        }
        timeString = timeString.replace(/Z$/i, '');
        timeString = timeString.replace(/([+-]\d{2}:?\d{2})$/i, '');
        timeString = timeString.split('.')[0];
      }

      let year, month, dayOfMonth;
      if (dateString.includes('-')) {
        [year, month, dayOfMonth] = dateString.split('-').map((x) => Number(x));
      } else if (dateString.includes('/')) {
        // Assume "MM/DD/YYYY" (browser locale formats) and fall back to Date parsing if ambiguous.
        const slashParts = dateString.split('/').map((x) => Number(x));
        if (slashParts.length === 3) {
          const [p1, p2, p3] = slashParts;
          // If the first part cannot be a month, treat as "DD/MM/YYYY"
          if (p1 > 12) {
            dayOfMonth = p1; month = p2; year = p3;
          } else {
            month = p1; dayOfMonth = p2; year = p3;
          }
        }
      }
      const [hours, minutes, seconds] = timeString.split(':').map((x) => Number(x));
      if (!year || !month || !dayOfMonth || Number.isNaN(hours) || Number.isNaN(minutes)) return null;

      return new Date(
        year,
        month - 1,
        dayOfMonth,
        hours,
        minutes,
        Number.isFinite(seconds) ? seconds : 0,
        0
      );
    },

    get_event_start_date_time() {
      if (!this.start_date) return null;

      // If `start_date` includes a time (API ISO string), prefer the separate `start_time`
      // field when present (editing existing events often provides both).
      if (String(this.start_date).includes('T')) {
        const dateOnly = String(this.start_date).split('T')[0];
        if (this.start_time) return this.parse_local_date_time(dateOnly, this.start_time);
        return this.parse_local_date_time(this.start_date);
      }

      // date + time inputs
      if (!this.start_time) return null;
      return this.parse_local_date_time(this.start_date, this.start_time);
    },

    get_event_end_date_time() {
      if (!this.end_date) return null;

      if (String(this.end_date).includes('T')) {
        const dateOnly = String(this.end_date).split('T')[0];
        if (this.end_time) return this.parse_local_date_time(dateOnly, this.end_time);
        return this.parse_local_date_time(this.end_date);
      }

      if (!this.end_time) return null;
      return this.parse_local_date_time(this.end_date, this.end_time);
    },

    validate_event_date_range() {
      // Clear first so the UI updates as the user edits.
      this.errors.start_date = null;
      this.errors.end_date = null;

      // When editing an event that has already started, the UI locks start/end dates.
      // In that state we should not block saving with "past date" validations.
      if (this.is_event_dates_locked) {
        return true;
      }

      const startObj = this.get_event_start_date_time();
      if (!startObj || !(startObj instanceof Date) || Number.isNaN(startObj.getTime())) {
        this.errors.start_date = 'Event start date/time is required';
        return false;
      }

      // Compare at minute precision to avoid false negatives when the user picks "now"
      // (inputs are minute-granularity but `Date()` has seconds/ms).
      const now = new Date();
      now.setSeconds(0, 0);

      if (startObj < now) {
        this.errors.start_date = 'Event start date/time cannot be in the past';
        return false;
      }

      const endObj = this.get_event_end_date_time();
      if(startObj && endObj){
        if (startObj >= endObj) {
          this.errors.end_date = 'event end date must be greater than the start date';
          return false;
        }
      }
      return true;
    },
    initialize_map() {
      if (!window.google?.maps?.places) return;

      const input = this.getActiveMapInput();
      // Guard clause for missing input or redundant initialization
      if (!input || (this.map_auto_complete && this.map_auto_complete_input === input)) {
        return;
      }

      this.setupAutocomplete(input);
    },

    getActiveMapInput() {
      const activeModal = document.querySelector('.modal.show');
      // 1. Check for specific ID inside an active modal
      const modalInput = activeModal?.querySelector('#mapSearchBox');
      if (modalInput) return modalInput;

      // 2. Resolve refs to a clean array
      const refs = Array.isArray(this.$refs.mapInput) ? this.$refs.mapInput : [this.$refs.mapInput];
      const validRefs = refs.filter(Boolean);

      // 3. Prioritize ref inside modal, otherwise take the first available ref
      return (activeModal ? validRefs.find((el) => activeModal.contains(el)) : null) || validRefs[0];
    },

    setupAutocomplete(input) {
      this.map_auto_complete = new window.google.maps.places.Autocomplete(input);
      this.map_auto_complete_input = input;
      this.map_auto_complete.addListener('place_changed', () => {
        const place = this.map_auto_complete.getPlace();
        if (!place?.geometry?.location) return;

        this.location = input.value;
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
      });
    },
    load_google_map_event() {
      if (typeof window.google !== 'undefined' && window.google.maps) {
        this.$nextTick(() => this.initialize_map());
        return;
      }

      const existingScript = document.getElementById('googleMapsScript');
      if (existingScript) {
        this.$nextTick(() => this.initialize_map());
        return;
      }

      const script = document.createElement('script');
      script.id = 'googleMapsScript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places&callback=initMap&v=weekly`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      window.initMap = () => {
        this.$nextTick(() => this.initialize_map());
      };
    },
    resetEvents() {
      this.page = 1;
      this.upcoming_events = [];
      this.has_more = true;
      this.has_loaded_upcoming_events = false;
      this.fetchEvents();
    },

    handleScroll() {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

      this.scrollTimeout = setTimeout(() => {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        const scrollBottom = container.scrollTop + container.clientHeight;
        const threshold = container.scrollHeight - 5; // trigger 50px before bottom

        if (scrollBottom >= threshold && this.has_more) {
          this.fetchEvents();
        }
      }, 200); // debounce delay
    },

    handle_my_events_scroll() {
      if (this.my_events_scroll_timeout) clearTimeout(this.my_events_scroll_timeout);

      this.my_events_scroll_timeout = setTimeout(() => {
        const container = this.$refs.my_events_scroll_container;
        if (!container) return;

        const scrollBottom = container.scrollTop + container.clientHeight;
        const threshold = container.scrollHeight - 5;

        if (scrollBottom >= threshold && this.my_events_has_more) {
          this.load_more_my_events();
        }
      }, 200);
    },
    startScanning(eventId) {
      this.scanResultBox = false;   // hide previous result
      this.scanSuccess = false;
      this.scanErrorMessage = "";
      this.scanData = {};
      this.currentEventId = eventId;
      this.showCamera = true;       // show video element
      this.scanning = true;
      this.isProcessing = false;
      $("#scanModal").modal("show");

      $("#scanModal").on("shown.bs.modal", () => {
        this.scanning = true;
        this.startCamera();
      });
    },
    startCamera() {
      const video = document.getElementById("scan_video");
      const canvas = document.getElementById("scan_canvas");
      if (!video || !canvas) return;
      const context = canvas.getContext("2d");

      navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
        .then(stream => {
          this.videoStream = stream;
          video.srcObject = stream;
          video.setAttribute("playsinline", true);
          requestAnimationFrame(() => this.scanLoop(video, canvas, context));
        })
        .catch(err => console.error("Camera error:", err));
    },

    scanLoop(video, canvas, context) {
      if (!this.scanning) return;

      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height, { inversionAttempts: "dontInvert" });

        if (code) {
          if (!this.isProcessing) {
            this.isProcessing = true;
            this.scanResult = code.data;
            let event = this.upcoming_events.find(event => event.id === this.currentEventId);
            if(!event.is_free)
            {
              this.validateTicket(code.data);
            }
            else
            {
              this.validate_rsvp(code.data);
            }

            setTimeout(() => { this.isProcessing = false; }, 2000);
          }
        }

      }

      requestAnimationFrame(() => this.scanLoop(video, canvas, context));
    },


    stopScanning() {
      this.scanning = false;
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());
        this.videoStream = null;
      }
      $("#scanModal").off("shown.bs.modal");
      $("#scanModal").modal("hide");
    },

    stopCameraOnly() {
      this.scanning = false;
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop());
      }
    },
    restartScan() {
      this.scanResultBox = false;
      this.showCamera = true;
      this.scanErrorMessage = "";
      this.scanData = {};

      this.isProcessing = false;
      this.scanning = true;

      this.startCamera();
    },
    validateTicket(scannedCode) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_ticket_qr_code/`,
        method: "POST",
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          event_id: this.currentEventId,
          unique_code: scannedCode
        }),

        success: (response) => {
          this.stopCameraOnly();

          this.scanSuccess = true;
          this.scanData = response;
          this.showCamera = false;
          this.scanResultBox = true;
        },

        error: (xhr) => {
          this.stopCameraOnly();

          this.scanSuccess = false;
          this.scanErrorMessage = xhr.responseJSON?.message || "Invalid or used ticket.";
          this.showCamera = false;
          this.scanResultBox = true;
        }
      });
    },
    validate_rsvp(scannedCode) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_rsvp_qr_code/`,
        method: "POST",
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          event_id: this.currentEventId,
          unique_code: scannedCode
        }),

        success: (response) => {
          this.stopCameraOnly();

          this.scanSuccess = true;
          this.scanData = response;
          this.showCamera = false;
          this.scanResultBox = true;
        },

        error: (xhr) => {
          this.stopCameraOnly();

          this.scanSuccess = false;
          this.scanErrorMessage = xhr.responseJSON?.message || "Invalid or used ticket.";
          this.showCamera = false;
          this.scanResultBox = true;
        }
      });
    },

    openModal(event) {
      this.selectEvent(event);
      if (!this.token_exists) {
        window.location = '/login';
        return;
      }

      if (event.is_free) {
        if (!this.token_exists) {
          window.location = '/login';
          return;
        }
        $('#eventModal').modal('show');
      } else {
        this.reset_promo();
        this.load_paid_event_tickets(event);
      }
    },
    load_paid_event_tickets(event) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event/`,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: JSON.stringify({
          event_id: event.id,
          user_id: this.user_details.user_id,
        }),
        success: (response) => {
          const fresh_event = response?.event || event;
          this.selectEvent(fresh_event);
          this.event_tickets = (fresh_event.event_tickets || []).map((ticket) => ({
            ...ticket,
            quantitySelected: 0,
          }));
          $('#ticket_modal').modal('show');
        },
        error: () => {
          Swal.fire({
            title: "Could not load tickets",
            text: "Please try again.",
            icon: "error",
          });
        },
      });
    },
    reset_promo() {
      this.promo_input = "";
      this.promo_message = "";
      this.promo_status = "";
      this.is_applying = false;
      this.applied_promo = null;
    },
    apply_promo() {
      const promo_code_name = (this.promo_input || "").trim();
      const event_id = this.selectedEvent?.id;
      if (!promo_code_name) return;

      if (!event_id) {
        this.promo_status = "error";
        this.promo_message = "Please select an event first.";
        return;
      }

      this.is_applying = true;
      this.promo_message = "";
      this.promo_status = "";

      const token = get_token();
      const headers = token
        ? {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          }
        : { "Content-Type": "application/json" };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/validate_event_promo_code/`,
        data: JSON.stringify({ promo_code_name, event_id }),
        processData: true,
        contentType: "application/json",
        headers,
        success: (response) => {
          if (response.status === "success") {
            this.applied_promo = response.data || null;
            this.promo_status = "success";
            this.promo_message = response.message || "Promo code applied.";
          } else {
            this.applied_promo = null;
            this.promo_status = "error";
            this.promo_message = response.message || "Invalid promo code.";
          }
        },
        error: (xhr) => {
          this.applied_promo = null;
          this.promo_status = "error";
          this.promo_message =
            xhr?.responseJSON?.message || "Invalid promo code for this event.";
        },
        complete: () => {
          this.is_applying = false;
        },
      });
    },
    calculate_subtotal() {
      return this.event_tickets.reduce((sum, ticket) => {
        const quantity = Number(ticket?.quantitySelected || 0);
        const price = Number(ticket?.price || 0);
        return sum + quantity * price;
      }, 0);
    },
    calculate_total() {
      const sub_total = this.calculate_subtotal();
      const promo = this.applied_promo;
      if (!promo) return sub_total.toFixed(2);

      const promoType = String(promo?.promo_code?.promo_code_type?.name || "").toLowerCase();
      const discountAmount = Number(promo?.promo_code?.discount_amount || 0);

      let total = sub_total;
      if (promoType === "percentage") {
        const percentage = Math.min(Math.max(discountAmount, 0), 100);
        total = sub_total - (sub_total * percentage) / 100;
      } else {
        total = sub_total - Math.max(discountAmount, 0);
      }

      total = Math.max(total, 0);
      return total.toFixed(2);
    },
    is_paid_event_sold_out(event) {
      if (event?.is_free) return false;
      const tickets = Array.isArray(event?.event_tickets)
        ? event.event_tickets
        : [];
      if (tickets.length === 0) return false;
      return tickets.every((ticket) => {
        const available = Number(ticket?.available_instances);
        return Number.isFinite(available) && available <= 0;
      });
    },
    countLimitedChapterRSVPs(event) {
      const eventName = event.event_name?.toLowerCase() || "";
      const isLimitedEvent = eventName.includes("bedfordview") || eventName.includes("edenvale");
      const rsvpCount = event.rsvp_list?.length || 0;
      return isLimitedEvent && rsvpCount >= 35;
    },

    toggleItem(item_id) {
          const index = this.selectedItemId.indexOf(item_id);

          if (index > -1) {
              this.selectedItemId = [];
          } else {
              this.selectedItemId = [item_id];
          }
      },
    canMakeRecurring(event) {
      const now = new Date();
      const end = new Date(`${event.end_date}T${event.end_time}`);
      return !event.is_recurring && end < now;
    },

    makeRecurring(event) {
      const patternId = this.recurrenceSelections[event.id];
      if (!patternId) {
        Swal.fire({
          title: 'Error',
          text: 'Please select a recurrence pattern.',
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      Swal.fire({
        title: 'Make this event recurring?',
        text: 'This will generate future events automatically.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/make_past_event_recurring/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`
            },
            data: {
              event_id: event.id,
              recurrence_pattern: patternId
            },
            success: () => {
              Swal.fire({
                title: 'Success',
                text: 'Event is now recurring!',
                icon: 'success',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
              this.recurrenceSelections[event.id] = '';
            },
            error: (xhr) => {
              Swal.fire({
                title: 'Error',
                text: xhr.responseJSON.error || 'Something went wrong.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    fetchRecurringTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recurring_pattern/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(append_active_organization_id({})),
        success: (response) => {
          this.recurring_patterns = response.data.recurring_patterns;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    setCurrentDate() {
      const today = new Date();

      // Format current month and year (e.g., "February 2025")
      this.currentMonthYear = today.toLocaleString("en-US", { month: "long", year: "numeric" });
    },

    formatRelativeDate(date) {
      const today = new Date();
      const diffTime = today - date; // Difference in milliseconds
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Difference in days

      if (diffDays === 0) {
        return "Today"; // Same day
      } else if (diffDays === 1) {
        return "Yesterday"; // 1 day ago
      } else if (diffDays < 7) {
        return `${diffDays} days ago`; // Less than a week ago
      } else if (diffDays < 30) {
        return `${Math.floor(diffDays / 7)} week(s) ago`; // Less than a month ago
      } else {
        return date.toLocaleString("en-US", { weekday: "long", day: "numeric", month: "long", year: "numeric" }); // Else display full date
      }
    },
    addMenuItem() {
      this.menu_items.push("");
    },
    removeMenuItem(index) {
      this.menu_items.splice(index, 1);
    },
    // filterExtras() {
    //   const searchText = this.selectedExtraText.toLowerCase();
    //   this.filteredExtras = this.extras.filter(extra => extra.name.toLowerCase().includes(searchText));
    // },
    getToken() {
      return get_token();
    },

    addEventToHome(newEvent) {
      if (newEvent) {
        this.events.unshift(newEvent);
      }
    },
    fetchPortals() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(append_active_organization_id({})),
        success: (data) => {
          this.portals = data.portals;
          this.portals = this.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },

    addExtra() {
      this.show_add_extras = true
      this.showExtrasForm = true;
      this.extraForms.push({
        selectedExtra: "",
        items: [
          { item_name: '', item_description: '', item_price: '' }
        ]
      });
    },

    addExtraItem(extra_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form) {
        const new_item = {
          item_name: '',
          item_description: '',
          item_price: 0
        };

        if (this.validate_extra_item(new_item)) {
          extra_form.items.push(new_item);
        }
      }
    },

    validate_extra_item(item) {
      return (
        typeof item === 'object' &&
        item !== null &&
        typeof item.item_name === 'string' &&
        typeof item.item_description === 'string' &&
        typeof item.item_price === 'number' &&
        item.item_price >= 0
      );
    },

    removeExtra(extraIndex) {
      this.extraForms.splice(extraIndex, 1);
    },
    addRsvp() {

      if (!this.token_exists) {
        const nextUrl = this.$router.currentRoute.value.fullPath;
        if (nextUrl) {
          sessionStorage.setItem('next', nextUrl);
          sessionStorage.setItem('selectedEvent', JSON.stringify(this.selectedEvent));
          sessionStorage.setItem('selectedExtras', JSON.stringify(this.selectedExtraId));
          sessionStorage.setItem('selectedItemId', JSON.stringify(this.selectedItemId))
          sessionStorage.setItem('businessName', JSON.stringify(this.businessName));
          sessionStorage.setItem('isFirstTime', JSON.stringify(this.isFirstTime));
          sessionStorage.setItem('chapter', JSON.stringify(this.chapter));
        }
        window.location = '/login';
        return;
      }
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('event_id', this.selectedEvent.id);
      if (Array.isArray(this.selectedItemId)) {
        this.selectedItemId.forEach(itemId => {
          formData.append('item_id', itemId);
        });
      } else {
        formData.append('item_id', this.selectedItemId);
      }
      formData.append('business_name', this.businessName || '');
      formData.append('is_first_time', this.isFirstTime ? 'True' : 'False');
      formData.append('chapter', this.chapter || '');
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            if(response.rsvp_data.rsvp_status.name ==='waitlisted')
              this.selectedEvent.is_waitlisted = true;
            else
              this.selectedEvent.is_rsvped = true;
            Swal.fire({
              icon: 'success',
              title: 'RSVP Successful',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {

              Swal.close();
              sessionStorage.removeItem('selectedEvent');
              sessionStorage.removeItem('selectedExtras');
              sessionStorage.removeItem('selectedItemId');
              sessionStorage.removeItem('businessName');
              sessionStorage.removeItem('isFirstTime');
              sessionStorage.removeItem('chapter');

              this.selectedEvent = {};
              this.selectedExtraId = [];
              this.businessName = '';
              $('#rsvp_modal').modal('hide');
            });
          }
        },
        error: (response) => {
          Swal.close();
          if (response.status === 401) {
            clear_token();
            window.location = '/login';
          }

          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            Swal.fire({
              icon: 'info',
              text: response_data.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              Swal.close();
              sessionStorage.removeItem('selectedEvent');
              sessionStorage.removeItem('selectedExtras');
              sessionStorage.removeItem('selectedItemId');
              sessionStorage.removeItem('businessName');
              sessionStorage.removeItem('isFirstTime');
              sessionStorage.removeItem('chapter');


              this.selectedEvent = {};
              this.selectedExtraId = [];
              this.selectedItemId = [];
              this.businessName = '';

              $('#rsvp_modal').modal('hide');
            });
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }

      })
    },
    handle_rsvp(event) {

      if (event.is_free) {

        this.fetchEvents_extras(event.id);
      } else {
        // Paid event → show ticket modal
        this.load_paid_event_tickets(event);
      }
    },
    process_to_checkout() {
      const selectedTickets = this.event_tickets
        .filter(t => t.quantitySelected > 0)
        .map(t => ({
          ticket_id: t.id,
          quantity: t.quantitySelected,
        }));
      if (selectedTickets.length === 0) {
        Swal.fire({
          title: "No tickets selected",
          text: "Please choose at least one ticket.",
          icon: "warning",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const request_data = {
        event_id: this.selectedEvent.id,
        tickets: selectedTickets,
        event_promo_code_id: this.applied_promo? this.applied_promo .id: this.applied_promo,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
        method: "POST",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {

            const orderData = response.data;
            $('#ticket_modal').modal('hide'); $('.modal-backdrop').remove();
            this.$router.push({ name: 'checkout', params: { order_id: orderData.id } });

          }
        },
        error: (xhr) => {
          Swal.fire({
            title: "Error",
            text: xhr.responseJSON.error || "Failed to create order.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          console.error("AJAX error:", xhr.responseText);
        }
      });

    },
    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId = []

      // Close the event modal before making the request
      $('#eventModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
    ,
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    deleteEvent(event_id) {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_api/`,
            data: JSON.stringify({ event_id: event_id }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The event has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  this.upcoming_events = this.upcoming_events.filter(event => event.id !== event_id);
                  this.past_events = this.past_events.filter(event => event.id !== event_id);
                  Swal.close();
                });
              }
            },
            error: (response) => {
              Swal.fire({
                title: 'Error!',
                text: response.responseJSON.message,
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              }

              );
            }
          });
        }
      });
    },
    fetchEventTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(append_active_organization_id({})),
        success: (response) => {
          this.event_types = response.data.event_type;
          this.event_types = this.event_types.map(type => {
            if (type.name === 'in_person') {
              return { ...type, name: 'in person' };
            }
            return type;
          });
          const selected_type_id = this.event_type?.id;
          const selected_type = this.event_types.find(
            type => String(type.id) === String(selected_type_id),
          );
          const default_type = this.event_types.find(type => type.name === 'in person');

          if (this.event_id && selected_type) {
            this.event_type = selected_type;
          } else if (!this.event_id && default_type) {
            this.event_type = default_type;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    resolve_active_organization_for_events() {
      if (!get_token()) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        $.ajax({
          type: "GET",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_my_organizations/`,
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
          success: (response) => {
            const organizations = response?.organizations || [];
            const active_organization_id = get_active_organization_id();
            const organization = organizations.find((item) => String(item?.id || item?.company_id || '') === String(active_organization_id || ''))
              || organizations.find((item) => item?.id || item?.company_id)
              || null;
            const organization_id = organization?.id || organization?.company_id;
            if (!organization_id) return;

            localStorage.setItem('active_organization_id', organization_id);
            this.user_details = {
              ...(this.user_details || {}),
              organization_id,
              organization_name: organization.company_name || organization.organization_name || this.user_details?.organization_name || '',
              company_name: organization.company_name || this.user_details?.company_name || '',
            };
          },
          complete: () => resolve(),
          error: () => resolve(),
        });
      });
    },
    fetchEvents() {
      if (
        this.is_upcoming_initial_loading ||
        this.is_upcoming_loading_more ||
        !this.has_more
      ) return;

      if (this.event_filters_active_for('upcoming')) {
        this.fetch_upcoming_search_results();
        return;
      }

      const user_id = this.user_details?.user_id;

      const is_initial_load = this.page === 1 && this.upcoming_events.length === 0;
      this.is_upcoming_initial_loading = is_initial_load;
      this.is_upcoming_loading_more = !is_initial_load;
      this.token_exists = get_token();
      $.ajax({
        url: this.get_events_endpoint(),
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
          }
          : {},
        contentType: "application/json",
        data: JSON.stringify(append_active_organization_id({ user_id: user_id, page: this.page, page_size: this.page_size, is_published:true })),
        success: (data) => {
          const status = data.status;


          if (status === "success") {

            const { results, has_more, page } = this.get_events_response_payload(data);

            (results || []).forEach(event => {
              if (!this.upcoming_events.some(e => e.id === event.id)) {
                this.upcoming_events.push(event);
              }
            });

            this.page = page + 1; // Increment page for next fetch
            // An empty page is terminal even if the API incorrectly reports has_more.
            // This prevents scroll-height changes from repeatedly fetching an empty page.
            this.has_more = Boolean(has_more && (results || []).length > 0);

          }

        },
        error: (xhr) => {
          this.has_more = false;
          console.error("Events API error:", xhr.responseText);
        },
        complete: () => {
          this.is_upcoming_initial_loading = false;
          this.is_upcoming_loading_more = false;
          this.has_loaded_upcoming_events = true;
        },
      });
    },
    filter_past_events() {
      this.is_event_loading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_past_events/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(append_active_organization_id({})),
        success: (data) => {

          this.past_events = data.data.events;

          setTimeout(() => {
            this.loading = false;
          }, 300);

        },
        complete: () => {
          this.is_event_loading = false;
        },
      });
    },

    form_date(dateString) {
      return new Date(dateString).toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    form_time(timeString) {
      if (!timeString) return "";
      const [hour, minute] = timeString.split(":");
      const date = new Date();
      date.setHours(hour, minute);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    open_create_event_modal_from_home() {
      if (this.$route.query?.create_event !== 'true') return;

      this.$nextTick(() => {
        $('#event_modal').modal('show');
      });
      this.$router.replace({ path: this.$route.path, query: {} });
    },

    openEditModal(event) {
      // Populate eventData for editing
      this.eventData = { ...event };
      $('#event_modal').modal('show');

    },

    submitEvent() {
      if (this.event_id) {
        this.update_event();
      } else {
        this.submit_form();
      }
  },

    update_event() {
      this.is_valid = true;
      if (!this.validation_event_form()) {
        return;
      }
      this.show_update_event_loading();
      this.submit_update_event_form(this.build_update_event_form_data());
    },


    load_event() {

      // this.fetchEvents();
      $("#update_event_modal").modal("hide");
      $('#event_modal').modal('hide');


      this.event_id = null;
      this.event_name = "";
      this.description = "";
      this.start_date = "";
      this.start_time = "";
      this.end_date = "";
      this.end_time = "";
      this.rsvp_start_date = "";
      this.rsvp_start_time = "";
      this.rsvp_end_date = "";
      this.rsvp_end_time = "";
      this.organizer = "";
      this.location = "";
      this.files = [];
      this.is_free = true;
    },
    validationEventForm() {
      this.errors = {};
      let valid = true;

      if (!this.event_name) {
        this.errors.event_name = 'Event name is required';
        valid = false;
      }

      return valid;
    },
    clearForm() {
      this.rsvp_end_time = "";
      this.end_time = "";
      this.start_time = "";
      this.rsvp_start_time = "";
      this.event_id = ''
      this.selectedTickets = [];
      this.tickets = [];
      this.assignedTicketIds = [];
      this.selectedTicketsData = [];
      this.is_free = true;
      this.edit_end_date = '';
      this.edit_is_sold_out = '';
      this.edit_start_date = '';
      this.edit_quantity = 0,
        this.edit_price = '';
      this.item_name = '';
      this.item_description = '';
      this.event_tickets = []
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.start_date = '';
      this.end_date = '';
      this.editing_event_start_ts = null;
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.ticket = {
        name: "",
        price: "",
        quantity: "",
        start_date: "",
        end_date: ""
      };
      // this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];
      this.show_add_extras = true
      this.show_rsvp_capacity = false;
      this.event_capacity = 0;

    },
    submit_form() {
      if (!this.validate_event_date_range?.()) {
        // Keep the modal open and show inline errors.
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const event_url = `${window.location.origin}${this.$route.path}`

      this.isSubmitting = true;
      const formData = new FormData();
      append_active_organization_form_data(formData);
      formData.append('event_name', this.event_name);
      formData.append('start_date', this.start_date.split('T')[0]);
      formData.append('start_time', this.start_date.split('T')[1]);
      if(this.end_date){
        formData.append('end_date', this.end_date.split('T')[0]);
        formData.append('end_time', this.end_date.split('T')[1]);
      }
      this.event_description = this.$refs.quillEventEditorRef.getHTML();
      formData.append('portal_id', this.selectedPortalId || '');
      formData.append('location', this.location);
      formData.append('event_type', this.event_type.id);
      if(this.event_link && this.event_link.trim()!==''){
        const url = this.normalize_url(this.event_link);
        formData.append('event_link', url);
      }
      formData.append('is_free', this.is_free);
      if(this.tickets.length >0){
        const ticketsPayload = this.tickets.map(t => ({
          ticket_name: t.name,
          price: t.price,
          quantity: t.quantity,
          start_date: t.start_date,
          end_date: t.end_date,
        }));
        formData.append('tickets', JSON.stringify(ticketsPayload));
      }


      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/create_event_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          this.$emit('new_event', response.event)
          Swal.close();
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Event Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#event_modal').modal('hide');
              this.isDropdownVisible = false;
              this.clearForm();
              this.my_events.unshift(response.event);
              this.errors={};
              const tabElement = document.querySelector('#my_events-tab');
                if (tabElement) {
                  const tab = new bootstrap.Tab(tabElement);
                  tab.show();
                }
            });
          }
        },
        error: (response) => {
          Swal.close();

          if (response.status === 401) {
            clear_token();
            window.location = '/login';
          }

          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.event_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    removeExtraItem(extra_index, item_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form && Array.isArray(extra_form.items)) {
        if (this.validate_item_index(extra_form.items, item_index)) {
          extra_form.items.splice(item_index, 1);
        }
      }
    },

    validate_item_index(items, index) {
      return Number.isInteger(index) && index >= 0 && index < items.length;
    },

    openCreateModal() {
      // Reset form fields for creating a new event
      this.event_name = '';
      this.description = '';
      this.start_date = '';
      this.start_time = '';
      this.end_date = '';
      this.end_time = '';
      this.rsvp_start_date = '';
      this.rsvp_start_time = '';
      this.rsvp_end_date = '';
      this.organizer = '';
      this.location = '';
      this.selectedPortalId = '';
      this.files = [];
      this.event_type = '';
      this.extraItems = [];

      // Show the modal
      $('#event_modal').modal('show');

    },
    formatDateInput(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toISOString().slice(0, 10); // Extracts "YYYY-MM-DD"
    },
    combine_date_time(datePart, timePart) {
      if (!datePart) return "";
      const safeDate = String(datePart).split('T')[0].trim();
      if (!timePart) return safeDate;

      let safeTime = String(timePart).trim();
      // Accept "HH:mm", "HH:mm:ss", "HH:mm:ssZ", "HH:mm:ss+02:00"
      safeTime = safeTime.replace(/Z$/i, '');
      safeTime = safeTime.replace(/([+-]\d{2}:?\d{2})$/i, '');
      safeTime = safeTime.split('.')[0];
      safeTime = safeTime.slice(0, 5); // "HH:mm"

      if (!safeTime || !safeTime.includes(':')) return safeDate;
      return `${safeDate}T${safeTime}`;
    },

    edit_event(event) {

      // Reset any previous edit state
      this.selectedTickets = [];
      this.assignedTicketIds = [];
      const originalStart = this.combine_date_time(event.start_date, event.start_time);
      const originalStartObj = new Date(originalStart);
      this.editing_event_start_ts = Number.isNaN(originalStartObj.getTime()) ? null : originalStartObj.getTime();

      this.event_name = event.event_name;
      this.event_id = event.id;
      this.description = event.description;
      const TextDescription = event?.description?.replace(/<[^>]*>/g, "");
      this.$nextTick(() => {
        if (this.$refs.quillEventEditorRef) {
          const quillEditor = this.$refs.quillEventEditorRef.getQuill();
          if (quillEditor) {
            quillEditor.setContents([
              { insert: TextDescription || "" },
            ]);
          }
        }
      });
      // Keep the same "datetime-local" compatible format used by the create flow.
      // This avoids validation/submission issues where the model lacks a "T" separator.
      this.start_date = this.combine_date_time(event.start_date, event.start_time);
      this.end_date = this.combine_date_time(event.end_date, event.end_time);
      this.rsvp_start_date = event.rsvp_start_date || event.start_date;
      this.rsvp_start_time = event.rsvp_start_time || event.start_time;
      this.rsvp_end_date = event.rsvp_end_date || event.end_date;
      this.rsvp_end_time = event.rsvp_end_time || event.end_time;
      this.organizer = event.organizer || "";
      this.location = event.location || "";
      this.is_free = event.is_free
      this.event_link = event.event_link;
      this.portal_id = event.portal_id;
      const event_type_id = event.event_type?.id;
      this.event_type = this.event_types.find(
        type => String(type.id) === String(event_type_id),
      ) || event.event_type;
      this.event_capacity =0;
      this.show_rsvp_capacity = false;
      if (event.rsvp_cap !=null)
      {
        this.event_capacity = event.rsvp_cap?.rsvp_max_capacity;
        this.show_rsvp_capacity = true;
      }
      if (event.event_extras && event.event_extras.length > 0) {
        this.showExtrasForm = true;
        this.extraForms = event.event_extras.map(extra => ({
          id: extra.extra.id,
          selectedExtra: extra.extra ? extra.extra.name : '',
          items: extra.items.map(item => ({
            id: item.id,
            item_name: item.item_name,
            item_description: item.description,
            item_price: item.price || 0
          }))
        }));

      } else {
        this.showExtrasForm = false;

      }
      if (event.rsvp_list && !event.rsvp_list.length > 0) {
        this.show_add_extras = true;
      }
      else {
        this.show_add_extras = false
      }

      if (!this.is_free) {

        this.event_tickets = event.event_tickets; // save it for computed

        event.event_tickets.forEach(et => {
          this.selectedTickets.push(Number(et.ticket.id));
          this.assignedTicketIds.push(Number(et.ticket.id));
        });
      } else {
        this.selectedTickets = [];
        this.assignedTicketIds = [];
      }

      // Reuse the create modal for editing (it already switches submit handler based on `event_id`)
      $('#event_modal').modal('show');
    },
    validation_event_form() {
      this.errors = {};
      let isValid = true;

      // 1. Event Name
      if (!this.event_name?.trim()) {
        this.errors.event_name = 'Event name is required';
        isValid = false;
      }

      // 2. Event Type
      if (!this.event_type || !this.event_type.id) {
        this.errors.event_type = 'Please select an event type';
        isValid = false;
      }

      // // 3. Organizer
      // if (!this.organizer?.trim()) {
      //   this.errors.organizer = 'Organizer is required';
      //   isValid = false;
      // }

      // 4. Event Link & Location
      if (this.event_type && this.event_type.name) {
        if (this.event_type.name === 'hybrid' || this.event_type.name === 'in person') {
          if (!this.location?.trim()) {
            this.errors.location = 'Location is required';
            isValid = false;
          }
        }
        if (this.event_type.name === "online" || this.event_type.name === "hybrid") {
          if (!this.event_link?.trim()) {
            this.errors.event_link = "Event link is required for online/hybrid events.";
            isValid = false;
          }
        }
      }

      // 5. Dates and Times
      if (!this.start_date) {
        this.errors.start_date = 'Event Start Date is required';
        isValid = false;
      }

      // In the edit flow, end date/time is required.
      if (!this.end_date) {
        this.errors.end_date = 'Event End Date is required';
        isValid = false;
      }

      if (this.start_date && !String(this.start_date).includes('T') && !this.start_time) {
        this.errors.start_time = 'Start time is required';
        isValid = false;
      }

      if (this.end_date && !String(this.end_date).includes('T') && !this.end_time) {
        this.errors.end_time = 'End time is required';
        isValid = false;
      }

      if (isValid) {
        const startObj = this.get_event_start_date_time?.();
        const endObj = this.get_event_end_date_time?.();
        if (!startObj || !endObj || Number.isNaN(startObj.getTime()) || Number.isNaN(endObj.getTime())) {
          this.errors.end_date = 'Please enter valid start/end date and time';
          isValid = false;
        } else if (!this.is_event_dates_locked && startObj >= endObj) {
          this.errors.end_date = 'event end date must be greater than the start date';
          isValid = false;
        }
      }
      // if (!this.rsvp_start_date && this.is_free) {
      //   this.errors.rsvp_start_date = 'RSVP Start Date is required';
      //   isValid = false;
      // }
      // if (!this.rsvp_end_date && this.is_free) {
      //   this.errors.rsvp_end_date = 'RSVP End Date is required';
      //   isValid = false;
      // }
      // if (!this.rsvp_start_time && this.is_free) {
      //   this.errors.rsvp_start_time = 'RSVP Start Time is required';
      //   isValid = false;
      // }
      // if (!this.rsvp_end_time && this.is_free) {
      //   this.errors.rsvp_end_time = 'RSVP End Time is required';
      //   isValid = false;
      // }
      const startTimeObj = new Date(`${this.start_date}`);
      const endTimeObj = new Date(`${this.end_date}`);
      if(!this.is_event_dates_locked && startTimeObj >= endTimeObj){
        isValid= false;
        this.errors.end_time = 'End time must be after start time';
      }
      // const startTimeRSVPObj = new Date(`${this.rsvp_start_date}T${this.rsvp_start_time}`);
      // const endTimeRSVPObj = new Date(`${this.rsvp_end_date}T${this.rsvp_end_time}`);
      // if(startTimeRSVPObj >=endTimeRSVPObj){
      //   isValid= false;
      //   this.errors.rsvp_end_time = 'RSVP End time must be after RSVP Start time';
      // }

      // Perform date comparison only if all date fields exist
      if (this.start_date && this.end_date) {
        const todayObj = new Date();
        const startDateObj = new Date(this.start_date);
        const endDateObj = new Date(this.end_date);
        // const rsvpStartDateObj = new Date(this.rsvp_start_date);
        // const rsvpEndDateObj = new Date(this.rsvp_end_date);
        

        todayObj.setHours(0, 0, 0, 0);
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
        // rsvpStartDateObj.setHours(0, 0, 0, 0);
        // rsvpEndDateObj.setHours(0, 0, 0, 0);

        if (startDateObj < todayObj && !this.is_event_dates_locked) {
          this.errors.start_date = 'Event Start Date must be today or a future date';
          isValid = false;
        }
        if (!this.is_event_dates_locked && endDateObj < startDateObj) {
          this.errors.end_date = 'Event End Date must be after Event Start Date';
          isValid = false;
        }
      //   if( this.is_free){
      //     if (rsvpStartDateObj > startDateObj) {
      //       this.errors.rsvp_start_date = 'RSVP Start Date must be today or before Event Start Date';
      //       isValid = false;
      //     }
      //     if (rsvpEndDateObj < rsvpStartDateObj || rsvpEndDateObj > startDateObj) {
      //       this.errors.rsvp_end_date = 'RSVP End Date must be after RSVP Start Date and on or before Event Start Date';
      //       isValid = false;
      //   }
      // }
      }

      // 6. Extras Validation
      // this.extraForms.forEach((extraForm, index) => {
      //   if (extraForm.selectedExtra) {
      //     extraForm.items.forEach((item, itemIndex) => {
      //       if (!item.item_name?.trim()) {
      //         this.errors[`extra_${index}_item_${itemIndex}_name`] = "Item name is required.";
      //         isValid = false;
      //       }
      //     });
      //   }
      // });
      // // check the valid rsvp capacity
      // if(this.show_rsvp_capacity && this.event_capacity<=0){
      //   this.errors.event_capacity = 'Event capacity must be greater than 1.';
      //   isValid= false;
      // }

      // if (!this.is_free) {
      //   this.selectedTicketsData.forEach((ticket) => {
      //     const key = `ticket_${ticket.id}`;

      //     // Required checks
      //     if (!ticket.start_date) {
      //       this.errors[`${key}_start_date`] = `Start date is required for ${ticket.name}`;
      //       isValid = false;
      //     }
      //     if (!ticket.end_date) {
      //       this.errors[`${key}_end_date`] = `End date is required for ${ticket.name}`;
      //       isValid = false;
      //     }
      //     if (!ticket.start_date || !ticket.end_date) return;

      //     const ticket_start_date = new Date(ticket.start_date);
      //     const ticket_end_date = new Date(ticket.end_date);

      //     const eventStart = new Date(`${this.start_date} ${this.start_time}`);

      //     // Logical checks
      //     if (ticket_start_date >= ticket_end_date) {
      //       this.errors[`${key}_end_date`] = ` End date must be after start date`;
      //       isValid = false;
      //     }

      //     // Ticket must be valid within event lifecycle
      //     if (ticket_start_date > eventStart) {
      //       this.errors[`${key}_start_date`] = `Ticket start cannot be after event start`;
      //       isValid = false;
      //     }

      //     if (ticket_end_date > eventStart) {
      //       this.errors[`${key}_end_date`] = ` Ticket sale must close before event starts`;
      //       isValid = false;
      //     }

      //   });
      // }

      return isValid;
    },
    validate_update_event_ticket_form() {
        this.errors = {};
        let isValid = true;

        // Required checks
        if (!this.edit_start_date) {
          this.errors.edit_start_date = 'Start date is required';
          isValid = false;
        }

        if (!this.edit_end_date) {
          this.errors.edit_end_date = 'End date is required';
          isValid = false;
        }

        if (!this.edit_start_date || !this.edit_end_date) {
          return isValid;
        }

        const ticket_start_date = new Date(this.edit_start_date);
        const ticket_end_date = new Date(this.edit_end_date);
        const eventStart = new Date(`${this.event_start_date} ${this.event_start_time}`);

        // Logical checks
        if (ticket_start_date >= ticket_end_date) {
          this.errors.edit_end_date = 'End date must be after start date';
          isValid = false;
        }

        // Ticket must be valid within event lifecycle
        if (ticket_start_date > eventStart) {
          this.errors.edit_start_date = 'Ticket start cannot be after event start';
          isValid = false;
        }

        if (ticket_end_date > eventStart) {
          this.errors.edit_end_date = 'Ticket sale must close before event starts';
          isValid = false;
        }
        if (this.edit_quantity < this.current_quantity) {
        this.errors.quantity = "Quantity should not be less that the current quantity"
        isValid = false;
      }

        return isValid;
      },

    generateCalendar() {
      const firstDay = new Date(this.year, this.month, 1);
      const lastDay = new Date(this.year, this.month + 1, 0);
      const numDays = lastDay.getDate();
      const startDay = firstDay.getDay();

      let days = [];

      // Previous month's days
      for (let i = startDay; i > 0; i--) {
        const prevMonthDate = new Date(this.year, this.month, -i + 1);
        days.push({ dayNumber: prevMonthDate.getDate(), otherMonth: true, date: prevMonthDate });
      }

      // Current month's days
      for (let i = 1; i <= numDays; i++) {
        days.push({ date: new Date(this.year, this.month, i), dayNumber: i, otherMonth: false });
      }

      // Next month's days
      let nextMonthDayCounter = 1;
      const remainingDays = 42 - days.length; // Ensure 6 rows
      for (let i = 0; i < remainingDays; i++) {
        const nextMonthDate = new Date(this.year, this.month + 1, nextMonthDayCounter++);
        days.push({ dayNumber: nextMonthDate.getDate(), otherMonth: true, date: nextMonthDate });
      }

      this.days = days;
    },
    prevMonth() {
      if (this.month === 0) {
        this.year--;
        this.month = 11;
      } else {
        this.month--;
      }
      this.generateCalendar();
    },

    nextMonth() {
      if (this.month === 11) {
        this.year++;
        this.month = 0;
      } else {
        this.month++;
      }
      this.generateCalendar();
    },

    getFormattedMonthYear() {
      return this.selectedDate.toLocaleDateString("en-US", { month: "short", year: "numeric" });
    },

    // 🟢 Change the month (offset can be +1 or -1)
    changeMonth(offset) {
      this.selectedDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth() + offset, 1);

      this.updateDaysInMonth(); // ✅ Ensure this runs after changing month

    },
    selectDay(day) {
      if (!day.date) return; // Ensure the day has a valid date

      this.selectedDay = day.dayNumber;
      this.selectedDate = day.date;

      const saDate = new Date(this.selectedDate).toLocaleDateString("en-CA", {
        timeZone: "Africa/Johannesburg",
      });


      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_events_by_date/`,
        method: 'POST',
        data: JSON.stringify({ event_start_date: saDate }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success' && response.events && response.events.length > 0) {
            this.events = response.events;
            this.message = '';
          } else {
            this.events = [];
            this.message = 'No events found.';
          }
        },
        error: () => {
          this.events = [];
          this.message = 'No events found.';
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    isSameDay(day) {
      const selected = new Date(this.selectedDate);
      selected.setHours(0, 0, 0, 0); // Reset time to midnight

      const current = new Date(day.date);
      current.setHours(0, 0, 0, 0); // Reset time to midnight

      return selected.getTime() === current.getTime();
    },

    selectEvent(event) {
      this.selectedEvent = event;
    },

    toggleDateExpanded(date) {
      if (this.expandedDates.includes(date)) {
        this.expandedDates = this.expandedDates.filter(d => d !== date);
      } else {
        this.expandedDates.push(date);
      }
    },
    getEventsForDate(date) {
      return this.events.filter(event => event.date === date);
    },
    toggleEvents(date) {
      this.activeDates[date] = !this.activeDates[date];
    },

    isWithinRSVPPeriod(event) {
      const now = new Date();
      const start = new Date(`${event.rsvp_start_date}T${event.rsvp_start_time}`);
      const end = new Date(`${event.rsvp_end_date}T${event.rsvp_end_time}`);
      if (now < start) {
        const openingDate = start.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "2-digit",
          month: "long",
        });
        const openingTime = start.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return ({
          isValid: false,
          reason: "not_started",
          message: "RSVP has not started yet.",
          openingText: `${openingDate} at ${openingTime}`,
        });
      }
      if (now > end) {
        const closingDate = end.toLocaleDateString("en-GB", {
          weekday: "long",
          day: "2-digit",
          month: "long",
        });
        const closingTime = end.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return ({
          isValid: false,
          reason: "ended",
          message: "RSVP period has ended.",
          closingText: `${closingDate} at ${closingTime}`,
        });
      }
      return ({ isValid: true, reason: "open", message: "" });
    },
    isEventStarted(event) {
      const now = new Date();
      // Combine date and time for start and end time
      const start = new Date(`${event.start_date}T${event.start_time}`);
      const end = new Date(`${event.end_date}T${event.end_time}`);

      var object = { canJoin: true, message: "" }
      // If the current time is before the event starts (checking both date and time)
      if (now < start) {
        object = { canJoin: false, message: "The event hasn't started yet." }
        return object;
      }
      // If the current time is after the event ends (checking both date and time)
      if (now > end) {
        object = { canJoin: false, message: "The event has ended." }
        return object;

      }
      return object;
    },
    exportToCSV(event) {
      if (!event || !event.rsvp_list || event.rsvp_list.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: 'No RSVP data available for export.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      const isCBO = this.cbo_domain; // Assuming this.cbo_domain is reactive
      let csvHeader = "First Name,Last Name,Email,Phone Number,Event";
      if (isCBO) {
        csvHeader += ",Business Name,First Time Attending,Chapter";
      }
      csvHeader += ",Meal\n";

      const csvRows = event.rsvp_list.map(user => {
        const firstName = user.user?.first_name || "";
        const lastName = user.user?.last_name || "";
        const email = user.user?.email || "";
        const phoneNumber = user.user?.phone_number || "";
        const eventName = user?.event_name || "";
        const meals = user.rsvp_items?.map(item => item.item?.item_name).join(", ") || "";

        let row = `${firstName},${lastName},${email},${phoneNumber},${eventName}`;

        if (isCBO) {
          const businessName = user.business_name || "";
          const firstTime = user.is_first_time ? "Yes" : "No";
          const chapter = user.chapter || "";
          row += `,${businessName},${firstTime},${chapter}`;
        }

        row += `,"${meals}"`;

        return row;
      });

      const csvContent = csvHeader + csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = event.event_name + ".csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    daysUntil(event) {
      const now = new Date();

      const start = new Date(`${event.start_date}T${event.start_time}`);
      let end = new Date(`${event.end_date}T${event.end_time}`);

      if (now > end) {
        return 'Event has passed';
      } else if (now >= start && now <= end) {
        const diffMs = end - now;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        if (diffHours > 0) {
          return `Event in progress (ends in ${diffHours}h ${diffMinutes}m)`;
        } else {
          return `Event in progress (ends in ${diffMinutes}m)`;
        }
      } else if (now < start) {
        const diffMs = start - now;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffHours < 1) {
          return 'Starts soon';
        } else if (diffHours < 24) {
          return `Starts in ${diffHours} hour${diffHours > 1 ? 's' : ''}`;
        } else if (diffDays < 7) {
          return `Starts in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
        } else {
          const weeks = Math.floor(diffDays / 7);
          const remainingDays = diffDays % 7;
          let result = `Starts in ${weeks} week${weeks > 1 ? 's' : ''}`;
          if (remainingDays > 0) {
            result += ` and ${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
          }
          return result;
        }
      }
    },
    get_event_timing_badge(event = {}) {
      const now = new Date(this.event_badge_now_ms || Date.now());
      const start = new Date(`${event?.start_date}T${event?.start_time}`);
      const end = new Date(`${event?.end_date}T${event?.end_time}`);

      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        return "Upcoming";
      }

      if (now > end) {
        return "Ended";
      }

      if (now >= start && now <= end) {
        return "Ongoing";
      }

      const diff_ms = start - now;
      const diff_minutes = Math.floor(diff_ms / (1000 * 60));
      const diff_hours = Math.floor(diff_ms / (1000 * 60 * 60));
      const diff_days = Math.floor(diff_ms / (1000 * 60 * 60 * 24));

      if (diff_minutes < 60) {
        return `Starts in ${Math.max(diff_minutes, 1)}m`;
      }

      if (diff_hours < 24) {
        const remaining_minutes = diff_minutes % 60;
        return `Starts in ${diff_hours}h ${remaining_minutes}m`;
      }

      if (diff_days < 7) {
        return `Starts in ${diff_days}d`;
      }

      const diff_weeks = Math.floor(diff_days / 7);
      const remaining_days = diff_days % 7;

      if (remaining_days > 0) {
        return `Starts in ${diff_weeks}w ${remaining_days}d`;
      }

      return `Starts in ${diff_weeks}w`;
    },

    formatDate(dateStr) {

      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      const month = date.toLocaleDateString('en-US', { month: 'long' });
      const year = date.getFullYear();

      // 🟢 Example: "Thursday, November 13th 2025"
      return `${weekday}, ${day}${suffix} ${month}  ${year}`;
    },

    cancelRSVP(event_id, user_id = null) {
      const token = this.getToken();


      if (!Number.isInteger(event_id)) {
        Swal.fire({
          title: 'Invalid ID',
          text: 'The event ID is not valid.',
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }

      const payload = { event_id }

      if (this.user_details.user_role === 'admin' && user_id) {
        payload.user_id = user_id
      }
      payload.base_url = `${window.location.origin}${this.$route.path}`;

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
        contentType: 'application/json',
        data: JSON.stringify(payload),
        headers: {
          'Authorization': `Token ${token}`
        },
        success: (data) => {
          if (data.status === 'success') {
            for (const event of this.upcoming_events) {
              if (event.id === event_id) {
                event.is_rsvped = false;
                break;
              }
            }

            Swal.fire({
              icon: 'success',
              title: 'RSVP Cancelled',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#eventModal').modal('hide');
              $('#exampleModal').modal('hide');
            })
          } else {
            Swal.fire({
              title: 'Error',
              text: data.message || 'Cancel failed',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        },
        error: (xhr) => {
          const response = xhr.responseJSON || {};
          Swal.fire({
            title: 'Error',
            text: response.message || 'Something went wrong',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    addTicket() {
      this.tickets.push({ name: '', price: 0, quantity: 0, end_date: '', start_date: '', });
    },
    removeTicket(index) {
      this.tickets.splice(index, 1);
    },
    fetchUserTickets() {
      this.is_tickets_loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/view_user_tickets/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success') {
            const purchasedTickets = (response.tickets || []).flatMap((order) =>
              (order.items || []).flatMap((item) =>
                (item.instances || []).map((instance) => ({
                  id: item.id,
                  order_id: order.id,
                  ticket_instance_id: instance.id,
                  event: order.event_name,
                  start_date: order.start_date,
                  end_date: order.end_date,
                  start_time: order.start_time,
                  end_time: order.end_time,
                  location: order.location,
                  ticket_name: item.ticket_name,
                  order_date: order.order_date,
                  price: item.unit_price,
                  unique_code: instance.unique_code,
                  qr_code: instance.qr_code,
                  is_redeemed: Boolean(instance.is_redeemed),
                  is_rsvp: false,
                }))
              )
            );
            const rsvpTickets = (response.rsvp_tickets || []).map((rsvp) => ({
              id: rsvp.id,
              event_id: rsvp.event_id,
              ticket_instance_id: `rsvp-${rsvp.id}`,
              event: rsvp.event_name,
              start_date: rsvp.event_date,
              end_date: rsvp.event_end_date,
              start_time: rsvp.event_start_time,
              end_time: rsvp.event_end_time,
              location: rsvp.event_location,
              ticket_name: "RSVP",
              order_date: null,
              price: 0,
              unique_code: rsvp.rsvp_code,
              qr_code: rsvp.qr_code,
              is_redeemed: Boolean(rsvp.is_attended),
              is_rsvp: true,
              rsvp_status: rsvp.rsvp_status,
            }));
            this.my_tickets = [...purchasedTickets, ...rsvpTickets];
          }
        },
        complete: () => {
          this.is_tickets_loading = false;
        }
      });
    },

    openTicketModal(ticket) {
      this.selectedTicket = ticket;
      $('#ticketModal').modal('show');
    },

    cancel_ticket(ticket) {
      const order_id = ticket?.order_id;
      const ticket_instance_id = ticket?.ticket_instance_id;

      Swal.fire({
        title: "Cancel this ticket?",
        text: "This will cancel only the selected ticket.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel",
        cancelButtonText: "Keep ticket",
        reverseButtons: true,
        toast: true,
        position: 'bottom-end',
      }).then((result) => {
        if (!result.isConfirmed) return;

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_ticket_order/`,
          method: "POST",
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            order_id,
            ticket_instance_ids: [ticket_instance_id]
          }),
          success: (response) => {
            if (response?.status === "success") {
              this.my_tickets = this.my_tickets.filter(
                (item) => String(item.ticket_instance_id) !== String(ticket_instance_id)
              );

              if (this.selectedTicket && String(this.selectedTicket.ticket_instance_id) === String(ticket_instance_id)) {
                this.selectedTicket = null;
              }

              $('#ticketModal').modal('hide');

              Swal.fire({
                title: "Ticket cancelled",
                text: response?.message || "Your ticket order has been cancelled.",
                icon: "success",
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          },
          error: (xhr) => {
            Swal.fire({
              title: "Cancellation failed",
              text: xhr?.responseJSON?.message || "We could not cancel this ticket order.",
              icon: "error",
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
      });
    },

    create_ticket() {
      Swal.fire({
        title: "Saving...",
        text: "Please wait while we create the ticket.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();

      formData.append("name", this.ticket.name);


      // 🚀 AJAX call
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/create_event_ticket/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.allTickets.push(response.ticket);
              $('#event_ticket_modal').modal('hide');
              this.clearForm(); // clear form
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response_data.message || "An error occurred while creating the Ticket, please try again.",
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },



    get_all_tickets() {

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets_type/`,
        headers: {
          Authorization: `Token ${this.getToken()}`
        },
        success: (response) => {

          this.allTickets = response.tickets || [];
        },
      });
    },
    get_filtered_tickets(query) {
      if (!query) return this.allTickets;
      const q = String(query).toLowerCase().trim();
      return this.allTickets.filter(t => t.name.toLowerCase().includes(q));
    },

    open_edit_ticket_modal(ticket) {
      this.edit_event_ticket = ticket
      this.edit_ticket_id = ticket.id
      this.edit_name = ticket.ticket.name  // read-only
      this.edit_price = ticket.price
      this.edit_start_date = ticket.start_date ? ticket.start_date.slice(0, 16) : ''
      this.edit_end_date = ticket.end_date ? ticket.end_date.slice(0, 16) : ''
      this.edit_is_sold_out = ticket.is_sold_out
      this.edit_quantity = ticket.quantity
      this.current_quantity = ticket.quantity
      this.event_start_date=ticket.event_start_date
      this.event_start_time=ticket.event_start_time

      $("#edit_ticket_modal").modal('show')
    },

    update_event_ticket() {
      this.is_valid = true
      if (!this.validate_update_event_ticket_form()) {
        return;
      }

      Swal.fire({
        title: "Saving...",
        text: "Please wait while we update the ticket.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const formData = new FormData();
      formData.append("ticket_id", this.edit_ticket_id)
      formData.append("price", this.edit_price);
      formData.append("start_date", this.edit_start_date)
      formData.append("end_date", this.edit_end_date)
      formData.append("quantity", this.edit_quantity)

      // 🚀 AJAX call
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_ticket/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.get_event_tickets(),
                $('#edit_ticket_modal').modal('hide');
              this.clearForm(); // clear form
            });
          }
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while creating the Ticket, please try again.",
            showConfirmButton: false,
            timer: 2000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },
    get_event_tickets() {

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets/`,
        headers: {
          Authorization: `Token ${this.getToken()}`
        },
        success: (response) => {

          this.event_tickets = response.tickets || [];
        },
        error: (xhr) => {

          if (xhr.status === 401) {
            window.location.href = "/login";
          }
        }
      });
    },
    view_attendees(event) {
      const event_id = event.id

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_ticket_instances/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ event_id }),
        success: (data) => {
          this.event_ticket_attendees = data.instances;
          this.isSubmitting = false;
          $('#event_user_ticket').modal('show');
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    newFormatDate(dateString) {
      if (!dateString) return 'N/A';
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      return new Date(dateString).toLocaleString(undefined, options);
    },
  get_event_media_files(event){
    return event.event_files.filter((file) => file.event_file_type.name === "event gallery")
  },
  get_event_resource_files(event){
    return event.event_files.filter((file) => file.event_file_type.name === "event resources")
  },
  has_agenda(event) {
    if (event?.agenda?.length) return true;
    return (event?.event_files || []).some((file) => {
      const name = String(file?.event_file_type?.name || "").toLowerCase();
      return name === "agenda" || name.includes("agenda");
    });
  },
  view_agenda(event){
    this.$refs.eventAgendaRef?.open_view_agenda?.(event);
  },
  validate_ticket_date(ticket_start_date){
    const targetDate = new Date(ticket_start_date);
    const today = new Date();
    if (targetDate > today) {
        return false;
    }
    return true;
  },
  add_speakers(event){
    this.$refs.eventSpeakerRef?.open_add_speakers?.(event);
  },
  add_promo_codes(event) {
    this.event_id = event?.id ?? null;
    this.$refs.promoManagerRef?.open_promo_code_manager_modal?.(event);
  },
  isPromoValid(startDateStr, endDateStr) {
    return this.$refs.promoManagerRef?.isPromoValid(startDateStr, endDateStr);
  },
  open_media_gallery(event) {
    this.event_id = event?.id ?? null;
    this.$refs.eventMediaGalleryRef?.open_media_gallery_modal?.(event);
  },
  open_document_upload(event) {
    this.event_id = event?.id ?? null;
    this.$refs.eventResourceRef?.open_document_modal?.(event);
  },
  open_agenda_create(event) {
    this.event_id = event?.id ?? null;
    this.$refs.eventAgendaRef?.open_create_agenda?.(event);
  },
  view_speakers(event){
    this.$refs.eventSpeakerRef?.open_view_speakers?.(event);
  },
  toggle_show_capacity_field(){
    this.show_rsvp_capacity = !this.show_rsvp_capacity
    let event = this.upcoming_events.find(event => event.id === this.event_id);
    if (this.show_rsvp_capacity ==false && event?.rsvp_cap){
      this.event_capacity = 0;
      $.ajax({
        type: "DELETE",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_rsvp_cap/`,
        data: JSON.stringify({ event_id: this.event_id}),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            const eventToUpdate = this.upcoming_events.find(event => event.id === this.event_id);
            if (eventToUpdate) {
              eventToUpdate.rsvp_cap = null;
            }
          }
        },
        error: (response) => {
          Swal.fire({
            title: 'Error!',
            text: response.responseJSON.message,
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          }
          );
        }
      });
    }
  },
  scrollTabs(direction) {
      const el = this.$refs.tabsContainer
      if (!el) return

      el.scrollBy({
        left: direction === 'right' ? 160 : -160,
        behavior: 'smooth'
      })
    },
    go_to_event(event) {
      const eventId = event?.id;
      if (!eventId) return;
      this.$router.push({ name: "view_event", params: { event_id: eventId } });
    },
    go_to_manage_event(event) {
      const eventId = event?.id;
      if (!eventId) return;
      this.$router.push({ name: "manage_event", params: { event_id: eventId } });
    },
    get_event_cover_profile(event){
      let event_file = event?.event_files?.find(file => file.event_file_type?.name === 'event_profile')
      return event_file?.file?.file_url || ''
    },
    upcoming_card_chips(event) {
      const chips = [];
      const relative = this.daysUntil?.(event);
      if (relative) chips.push(relative);

      if (event?.is_recurring) chips.push('Recurring');
      chips.push(event?.is_free ? 'Free' : 'Paid');

      return chips.slice(0, 3);
    },

    get_event_min_price(event) {
      const items = Array.isArray(event?.event_tickets) ? event.event_tickets : [];
      const prices = items
        .map((t) => Number(t?.price))
        .filter((n) => Number.isFinite(n) && n >= 0);
      if (!prices.length) return null;
      return Math.min(...prices);
    },

    format_zar(amount) {
      const value = Number(amount);
      if (!Number.isFinite(value)) return '';
      const hasDecimals = Math.abs(value % 1) > 0.000001;
      const formatted = new Intl.NumberFormat('en-ZA', {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
      }).format(value);
      return `R${formatted}`;
    },

    upcoming_price_info(event) {
      if (event?.is_free) {
        return ({ label: '', value: 'Free' });
      }
      const min = this.get_event_min_price(event);
      if (min === null) {
        return ({ label: '', value: 'Tickets' });
      }
      return ({
        label: 'From',
        value: this.format_zar(min)
      });
    },
    event_share_url(event) {
      return `${window.location.origin}/view_event/${event?.id}`;
    },

    toggle_share_menu(id) {
      const isOpen = this.is_share_menu_open(id);
      if (isOpen) {
        this.close_share_menu(id);
        return;
      }

      const next_share_menu_open = {};
      Reflect.set(next_share_menu_open, id, true);
      this.share_menu_open = next_share_menu_open;
    },
    is_share_menu_open(id) {
      return !!Reflect.get(this.share_menu_open || {}, id);
    },
    close_share_menu(id) {
      const next_share_menu_open = { ...(this.share_menu_open || {}) };
      Reflect.set(next_share_menu_open, id, false);
      this.share_menu_open = next_share_menu_open;
    },
    share_link_email(event) {
      const url = this.event_share_url(event);
      const subject = (event?.event_name ?? 'Event').toString();
      return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(url)}`;
    },
    async copy_event_link(event) {
      const link = this.event_share_url(event);
      let didCopy = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(link);
          didCopy = true;
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = link;
          textArea.setAttribute('readonly', '');
          textArea.className = 'clipboard-copy-buffer';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          didCopy = true;
        }
      } catch (err) {
        console.warn('Unable to copy event link', err);
      } finally {
        if (didCopy) {
          Swal.fire({
            icon: "success",
            title: "Link copied",
            showConfirmButton: false,
            timer: 1200,
            position: "bottom-end",
            toast: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Copy failed",
            text: "Unable to copy link. Please try again.",
            showConfirmButton: false,
            timer: 1800,
            position: "bottom-end",
            toast: true,
          });
        }
        this.close_share_menu(event?.id);
      }
    },

    share_link_facebook(event) {
      const url = this.event_share_url(event);
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    },

    share_link_twitter(event) {
      const url = this.event_share_url(event);
      const text = (event?.event_name ?? 'Event').toString();
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    },

    share_link_whatsapp(event) {
      const url = this.event_share_url(event);
      const text = (event?.event_name ?? 'Event').toString();
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(`${text} - ${url}`)}`;
    },

    closeMenu(eventId) {
      const el = document.getElementById(`menu-open-${eventId}`);
      if (el && 'checked' in el) el.checked = false;
    },
    rsvp_button(event){
      return event.is_free && (event.rsvp_cap?.rsvp_current_count < event.rsvp_cap?.rsvp_max_capacity || !event.rsvp_cap)
    },
    validate_user(event){
      return this.token_exists && (this.user_details.user_role === 'admin' || String(event?.user?.id) === String(this.get_user_id()))
    },
    check_description(html) {
    if (!html) return false;
    const plainText = html.replace(/<[^>]*>/g, '').trim();
    return plainText.length > 0;
    },
    get_icon_class(item) {
      return this.$refs.eventResourceRef.get_icon_class(item);
    },
     get_file_type_label(item) {
      return this.$refs.eventResourceRef.get_file_type_label(item);
    },
    get_file_name(item) {
     return this.$refs.eventResourceRef.get_file_name(item);
    },
    get_file_url(item) {
      return this.$refs.eventResourceRef.get_file_url(item);;
    },
    open_preview(item){
      this.$refs.eventResourceRef.open_preview(item);
    },
    download_document(item){
      this.$refs.eventResourceRef.download_document(item);
    },
    open_promo_code_modal(event){
      this.selected_event_agenda = event;
       $('#availablePromosModal').modal('show');
    },
    selectPromo(promo) {
      navigator.clipboard.writeText(promo).then(() => {
        this.showToast('Link copied to clipboard!');
      })
    },
    showToast(message) {
      document.querySelector('#copyToast .toast-body').textContent = message;

      $('#copyToast').fadeIn(300).addClass('show');
      setTimeout(function () {
        $('#copyToast').fadeOut(30).removeClass('show');
      }, 3000);
    },

    // ---- My Events card helpers (UI) ----
    my_event_state(event) {
      const statusRaw = (event?.is_published || '').toString().toLowerCase();
      if (!statusRaw) return 'draft';
      if (statusRaw) return 'published';
    },

    is_online_event(event) {
      const typeRaw = (
        event?.event_type?.name ||
        ''
      ).toString().toLowerCase();
      return typeRaw.includes('online') ;
    },

    get_location_text(event) {
      if (this.is_online_event(event)) return 'Online';
      return (
        event?.location ||
        ''
      ).toString().trim();
    },
  qr_code(base64String) {
      return `data:image/png;base64,${base64String}`;
    },
  get_user_events (reset = false){
    if (reset) {
      this.my_events_page = 1;
      this.my_events_has_more = true;
      this.my_events_total_pages = 0;
      this.my_events = [];
    }

    if (!this.my_events_has_more && !reset) return;

    // Only show the big loader on first page; use a smaller "loading more" state for pagination.
    this.is_my_events_loading = this.my_events_page === 1;
    this.is_my_events_loading_more = this.my_events_page > 1;

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_user_events/`,
       headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
      data: JSON.stringify(append_active_organization_id({ page: this.my_events_page, page_size: this.my_events_page_size })),
      success: (response) => {
        const status = response.status;
        if (status === "success") {
          const payload = response?.data || {};
          const results = Array.isArray(payload?.results) ? payload.results : [];

          if (this.my_events_page === 1) {
            this.my_events = results;
          } else {
            this.my_events = [...this.my_events, ...results];
          }

          this.my_events_total_pages = Number(payload?.total_pages || 0);
          this.my_events_has_more = !!payload?.has_more;
        }

        this.is_my_events_loading = false;
        this.is_my_events_loading_more = false;
      },
      error: (response) => {
        this.is_my_events_loading = false;
        this.is_my_events_loading_more = false;
        Swal.fire({
          title: 'Error!',
          text: response.responseJSON.message,
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        }
        );
      }
    });
  },

  load_more_my_events() {
    if (this.is_my_events_loading || this.is_my_events_loading_more || !this.my_events_has_more) return;
    this.my_events_page += 1;
    this.get_user_events(false);
  }
  },
};
